export default __webpack_public_path__ + "static/media/postcards-bg.afacc65e.jpg";